'use strict';

const PaymentButtonTracking = require('od-modules/../tracking/ancillaries_tracking/ancillaries_payment_button');

const formatTrackingPrice = (price) => Number.isFinite(price) ? Math.floor(price) : 'NA';

const getTrackingPrices = ({totalWithoutGuarantee, totalWithGuarantee}) => ({
    priceWithoutInsurance: formatTrackingPrice(totalWithoutGuarantee),
    priceWithInsurance: formatTrackingPrice(totalWithGuarantee),
});

class TrackingHandler {
    load(id, prices) {
        this.id = id;
        this.handler = new PaymentButtonTracking(id, getTrackingPrices(prices));
    }

    getHandler() {
        return this.handler;
    }

    launchInfoMessageTracking(opened = false) {
        return opened
            ? this.launch('whatIsClose')
            : this.launch('whatIsOpen');
    }

    launch(method, id) {
        this.getMethodByName(method).apply(this.getHandler(), [id || this.id]);
    }

    getMethodByName(method = '') {
        const handler = this.getHandler();
        return handler && handler[method] || (() => {});
    }
}

module.exports = new TrackingHandler();
